import { ruleStatus } from '../inventoryApproval.types';

// ─── API error response ───
export interface ApprovalRuleApiErrorItem {
  code: string;
  detail: string;
  attr: string | null;
}

export interface ApprovalRuleApiError {
  type: string;
  errors: ApprovalRuleApiErrorItem[];
}

// ─── Roles API response ───
export interface RoleItem {
  id: number;
  name: string;
  is_doctor: boolean | null;
  name_label: string;
}

export interface RolesResponse {
  meta: {
    limit: number;
    next: string | null;
    offset: number;
    previous: string | null;
    total_count: number;
  };
  objects: RoleItem[];
}

// ─── Approval Level for form ───
export interface ApprovalLevelFormValues {
  id?: number; // Optional for new levels
  level: number;
  role: number | null;
  escalationTime: string;
  escalationRole: number | null;
  isMandatory: boolean;
  skipIfSameUser: boolean;
}

// ─── Create Approval Rule form values ───
export interface CreateApprovalRuleFormValues {
  ruleName: string;
  documentType: number | null;
  clinicId: number | null;
  status: ruleStatus | '';
  minAmount: number | null;
  maxAmount: number | null;
  isUnlimited: boolean;
  approvalLevels: ApprovalLevelFormValues[];
  notifyEmail: boolean;
  notifySystem: boolean;
}

// ─── Initial values ───
export const CREATE_APPROVAL_RULE_INITIAL_VALUES: CreateApprovalRuleFormValues = {
  ruleName: '',
  documentType: null,
  clinicId: null,
  status: '',
  minAmount: null,
  maxAmount: null,
  isUnlimited: false,
  approvalLevels: [
    {
      level: 1,
      role: null,
      escalationTime: '',
      escalationRole: null,
      isMandatory: false,
      skipIfSameUser: false,
    },
  ],
  notifyEmail: true,
  notifySystem: false,
};

// ─── API Payload types ───
export interface CreateApprovalRuleLevelPayload {
  level_number: number;
  role: number;
  escalation_role: number | null;
  escalation_time_hours: number | null;
  escalation_time_minutes: number | null;
  is_mandatory: boolean;
  skip_if_same_user: boolean;
}

export interface CreateApprovalRulePayload {
  name: string;
  document_type: number;
  clinic: number;
  min_amount: string;
  max_amount: string | null;
  status: ruleStatus;
  priority: number;
  is_mandatory: boolean;
  is_email: boolean;
  is_system: boolean;
  levels: CreateApprovalRuleLevelPayload[];
}
